export const menuItems = [
  { text: "Home", url: "/" },
  { text: "About", url: "/about" },
  { text: "Services", url: "/services" },
  { text: "Portfolio", url: "/portfolio" },
  { text: "Contact", url: "/contact" },
]
